import React from 'react';

const StatusCardsSkeleton = ({ count = 4, className = "" }) => {
  return (
    <>
      <style>{`
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        .shimmer-animation {
          animation: shimmer 2s infinite;
        }
      `}</style>
      
      <div className={`w-full flex gap-4 ${className}`}>
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className="flex flex-col gap-2 w-full bg-white p-4 rounded border border-mutedGray relative overflow-hidden"
          >
            {/* Shimmer overlay */}
            <div className="absolute inset-0 shimmer-animation bg-gradient-to-r from-transparent via-white/60 to-transparent" />
            
            {/* Content skeleton */}
            <div className="flex flex-row items-center gap-2 relative z-10">
              {/* Count skeleton */}
              <div className="h-9 w-16 bg-gray-200 rounded animate-pulse" />
              {/* Percentage skeleton - only show for non-first cards */}
              {index > 0 && (
                <div className="h-5 w-12 bg-gray-200 rounded animate-pulse" />
              )}
            </div>
            {/* Title skeleton */}
            <div className="h-4 w-24 bg-gray-200 rounded animate-pulse relative z-10" />
          </div>
        ))}
      </div>
    </>
  );
};

export default StatusCardsSkeleton;